import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Settings = () => {
  const [userId, setUserId] = useState('');
  const [username, setUsername] = useState('');
  const [designation, setDesignation] = useState('');
  const [email, setEmail] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [departmentCode, setDepartmentCode] = useState('');
  const [specialization, setSpecialization] = useState('');
  const [image, setImage] = useState(sessionStorage.getItem("photo") || "https://png.pngtree.com/png-vector/20190710/ourlarge/pngtree-user-vector-avatar-png-image_1541962.jpg");
  const [accessLevel, setAccessLevel] = useState(sessionStorage.getItem("accessLevel") || '');  // Access level added
  const [, setUsers] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/users`; // Update with your backend URL

  useEffect(() => {
    const sessionData = {
      designation: sessionStorage.getItem('designation'),
      email: sessionStorage.getItem('email'),
      userId: sessionStorage.getItem('userId'),
      username: sessionStorage.getItem('username'),
      accessLevel: sessionStorage.getItem('access_level'),  // Retrieve accessLevel from sessionStorage
    };

    if (sessionData.userId) {
      setUserId(sessionData.userId);
      setUsername(sessionData.username);
      setDesignation(sessionData.designation);
      setEmail(sessionData.email);
      setAccessLevel(sessionData.accessLevel);  // Set accessLevel
      setIsEditMode(true);  // Set edit mode to true if userId exists in sessionStorage
      handleEdit(sessionData.userId);  // Fetch user details using userId from sessionStorage
    } else {
      setDesignation(sessionData.designation);
      setEmail(sessionData.email);
      setUsername(sessionData.username);
    }
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(apiUrl);
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleEdit = async (id) => {
    if (!id) {
      console.error('User ID is required to edit.');
      return;
    }

    try {
      const response = await axios.get(`${apiUrl}/${id}`);
      const userData = response.data;

      setUserId(userData.userId);
      setUsername(userData.username);
      setDesignation(userData.designation);
      setEmail(userData.email);
      setContactNumber(userData.contactNumber);
      setDepartmentCode(userData.department.deptId.toString());
      setSpecialization(userData.specialization);
      setAccessLevel(userData.accessLevel);
      setImage(userData.photo);
      setIsEditMode(true);
    } catch (error) {
      console.error('Error fetching user:', error.response ? error.response.data : error.message);
    }
  };

  const handleUpdate = async (id) => {
    try {
      const updatedUser = {
        userId,
        username,
        designation,
        email,
        contactNumber,
        department: { deptId: departmentCode },
        specialization,
        accessLevel,
        photo: image,  // Include the photo in the updated data
      };

      await axios.put(`${apiUrl}/${id}`, updatedUser);

      // Show success toast
      toast.success('User updated successfully!');
      setIsEditMode(false);
      clearForm();
      function logout() {
        setTimeout(() => {
          sessionStorage.removeItem("userEmail");
          sessionStorage.clear();
          window.location.href = "/login";
        }, 10);
      }
      setTimeout(() => {
        logout();
      }, 2000);
    } catch (error) {
      // Show error toast
      toast.error('Error updating user: ' + (error.response ? error.response.data : error.message));
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const clearForm = () => {
    setUserId('');
    setUsername('');
    setDesignation('');
    setEmail('');
    setContactNumber('');
    setDepartmentCode('');
    setSpecialization('');
    setImage(sessionStorage.getItem("photo") || "https://png.pngtree.com/png-vector/20190710/ourlarge/pngtree-user-vector-avatar-png-image_1541962.jpg"); // Reset to session image
    setAccessLevel(sessionStorage.getItem("accessLevel") || '');  // Reset accessLevel
    setIsEditMode(false);
  };

  const formInputStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '1rem',
    backgroundColor: '#f9f9f9',
    color: '#333',
  };

  const formInputDisabledStyle = {
    ...formInputStyle,
    backgroundColor: '#f1f1f1',
    color: '#777',
  };

  return (
    <div className="container mt-5">
      <div className="card mx-auto" style={{ maxWidth: '500px' }}>
        <div className="card-body d-flex align-items-center">
          <img
            src={image}
            alt="Profile"
            className="me-3 border"
            style={{
              width: "150px",
              height: "140px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
          <div>
            <h5>{username}</h5>
            <h6>{designation}</h6>
            <p>{email}</p>
          </div>
        </div>
        <hr />

        <div className="p-3">
          <label htmlFor="User_ID" className="form-label">USER ID :</label>
          <input
            id="User_ID"
            type="text"
            className="form-control"
            style={isEditMode ? formInputDisabledStyle : formInputStyle}
            placeholder="User_ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            readOnly={isEditMode}
          />

          <label htmlFor="Username" className="form-label mt-3">USER NAME :</label>
          <input
            id="Username"
            type="text"
            className="form-control"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <div className="row mt-3">
            <div className="col-md-4">
              <label htmlFor="Email_ID" className="form-label">EMAIL :</label>
              <input
                id="Email_ID"
                type="text"
                className="form-control"
                style={formInputDisabledStyle}
                placeholder="Email_ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="Contact" className="form-label">CONTACT :</label>
              <input
                id="Contact"
                type="text"
                className="form-control"
                placeholder="Contact Number"
                value={contactNumber}
                onChange={(e) => setContactNumber(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="Dept_ID" className="form-label">DEPT ID :</label>
              <input
                id="Dept_ID"
                type="text"
                style={formInputDisabledStyle}
                readOnly
                className="form-control"
                placeholder="Dept_ID"
                value={departmentCode}
                onChange={(e) => setDepartmentCode(e.target.value)}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-md-6">
              <label htmlFor="Specialization" className="form-label">SPECIALIZATION :</label>
              <input
                id="Specialization"
                type="text"
                className="form-control"
                placeholder="Specialization"
                value={specialization}
                onChange={(e) => setSpecialization(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="Designation" className="form-label">DESIGNATION :</label>
              <input
                id="Designation"
                type="text"
                className="form-control"
                placeholder="Designation"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
              />
            </div>
            <label htmlFor="ProfileImage" className="form-label mt-3">Upload Profile Image:</label>
            <input
              id="ProfileImage"
              type="file"
              className="form-control"
              onChange={handleImageChange}
            />
          </div>

          <div className="d-flex justify-content-center mt-4">
            <button
              className="btn btn-dark-blue mx-2 w-25"
              onClick={isEditMode ? () => handleUpdate(userId) : () => handleEdit(userId)}
            >
              {isEditMode ? 'Update' : 'Edit'}
            </button>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Settings;
